import { render } from "./minutes.vue?vue&type=template&id=5bcc8b78&scoped=true"
import script from "./minutes.vue?vue&type=script&lang=js"
export * from "./minutes.vue?vue&type=script&lang=js"

import "./minutes.vue?vue&type=style&index=0&id=5bcc8b78&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcc8b78"]])

export default __exports__